<template>
    <div :class="{ 'card card-stats card-raised': card }">
        <div :class="{ 'card-body' : card }" v-if="status">

            <h3 v-if="!hideTitle" class="mb-0 d-flex align-items-center">
                <i v-if="showCollapseToggle"
                   class="fa fa-chevron-right fa-fw mr-2 cursor-pointer chevron-toggle"
                   :class="{ 'chevron-expanded': !collapsed }"
                   @click="$emit('toggle-collapse')"
                   style="font-size: 0.9em;"></i>
                Dispense Status
            </h3>

            <div v-if="!collapsed" class="row justify-content-md-center">
                <div class="col">
                    <CounterIndicator :counts="status.getDispenseCounts('printQueue', 'printQueueRevenue')"
                        :warning-limit="getWarningLimit('PrintQueueWarningLimit')" :name="printQueueName"
                        route-name="PrintQueue"></CounterIndicator>
                </div>

                <div class="col">
                    <CounterIndicator :counts="status.getDispenseCounts('outOfStock', 'outOfStockRevenue')"
                        :warning-limit="getWarningLimit('OutOfStockWarningLimit')" name="Out Of Stock"
                        route-name="PrintQueue" :route-query="{ oos: 'true' }"></CounterIndicator>
                </div>
                <div class="col">
                    <CounterIndicator :counts="status.getDispenseCounts('printedNotFilled', 'printedNotFilledRevenue')"
                        :secondary-counts="status.getDispenseCounts('printedNotFilled48hrs')"
                        :warning-limit="getWarningLimit('PrintedNotFilledWarningLimit')" name="Printed Not Filled"
                        route-name="PrintQueue" :route-query="{ recent: 'true' }"></CounterIndicator>
                </div>
                <div class="col">
                    <CounterIndicator
                        :counts="status.getDispenseCounts('filledNotVerified', 'filledNotVerifiedRevenue')"
                        :secondary-counts="status.getDispenseCounts('filledNotVerified48hrs')"
                        :warning-limit="getWarningLimit('FilledNotVerifiedWarningLimit')" name="Filled Not Verified"
                        route-name="VerificationQueue"></CounterIndicator>
                </div>
                <div class="col">
                    <CounterIndicator :counts="status.getDispenseCounts('verifiedToday', 'verifiedTodayRevenue')"
                        :warning-limit="getWarningLimit('VerifiedTodayWarningLimit')" name="Verified Today"
                        :alert-above-limit="false" route-name="VerificationQueue"></CounterIndicator>
                </div>
                <b-col>
                    <CounterIndicator
                        :counts="status.getDispenseCounts('verifiedNotShipped', 'verifiedNotShippedRevenue')"
                        :warning-limit="getWarningLimit('OrderVerifiedNotShippedWarningLimit')"
                        name="Verified not Shipped" route-name="VerifiedNotShippedQueue"></CounterIndicator>
                </b-col>
                <div class="col">
                    <CounterIndicator :counts="status.getDispenseCounts('openErrors', 'openErrorsRevenue')"
                        :warning-limit="getWarningLimit('PendingErrorsQueueWarningLimit')" name="Open Errors"
                        :alert-above-limit=false route-name="DispenseErrors"></CounterIndicator>
                </div>
                <div class="col">
                    <CounterIndicator :counts="status.getDispenseCounts('pv1Queue', 'pv1QueueRevenue')"
                        :warning-limit="getWarningLimit('PV1QueueWarningLimit')" name="PV1" route-name="PV1QueuePage">
                    </CounterIndicator>
                </div>
                <div class="col">
                    <CounterIndicator :counts="status.getDispenseCounts('pickupQueue', 'pickupQueueRevenue')"
                        :warning-limit="getOldestPickUpLimit('PickUpOrdersLimit')" name="Pick-Up Queue"
                        route-name="PickupQueue"></CounterIndicator>
                </div>
                <b-col>
                    <CounterIndicator :counts="status.getDispenseCounts('orderAuditQueueCount', 'orderAuditRevenue')"
                        :warning-limit="getWarningLimit('OrderAuditQueueLimit')" name="Order Audit Queue"
                        route-name="OrderAuditQueue"></CounterIndicator>
                </b-col>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import CounterIndicator from "@/components/Dashboard/CounterIndicator.vue"
import { DashboardStatus } from "@/models/DashboardStatus";
import moment from "moment/moment";

@Component({
    components: {
        CounterIndicator,
    }
})
export default class DispenseStatusComponent extends Vue {

    @Prop({ default: true }) card!: boolean;
    @Prop({ default: false }) hideTitle!: boolean;
    @Prop({ default: false }) showCollapseToggle!: boolean;
    @Prop({ default: false }) collapsed!: boolean;

    get status(): DashboardStatus {
        if (this.$root.$data.dashboardData) {
            return this.$root.$data.dashboardData as DashboardStatus;
        }
        return new DashboardStatus();
    }

    get printQueueName() {
        return this.$pageNames?.printQueue ?? "Print Queue";
    }

    getWarningLimit(counterName: string): number | null {
        const val = this.status?.getConfigValue(counterName) || '';
        if (isNaN(parseFloat(val))) return null;

        return parseFloat(val);
    }

    getOldestPickUpLimit(_counterName: string): number | null {
        const oldestPickups = this.status?.dispenseStatus.map(ds => moment(ds.oldestPickUp).toDate());
        if (!oldestPickups) return null;
        let isBeyondLimit = false;
        const limitDate = moment().add(-5, 'days').toDate();
        oldestPickups.forEach(element => {
            if (element < limitDate) {
                isBeyondLimit = true;
                return;
            }
        });
        if (isBeyondLimit) return Number.MIN_VALUE;
        return null;
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}

.chevron-toggle {
    transition: transform 0.3s ease;
    display: inline-block;
}

.chevron-expanded {
    transform: rotate(90deg);
}
</style>
